<template>
	<div class="flex items-center gap-2 bg-grey-11 rounded-lg p-3">
		<div>
			<img src="@/assets/img/icon-wallet.png" alt="" class="w-4 ">
		</div>

		<div class="grow">
			{{ contractConfigs.weightInGram }} g
			Avail. Balance
		</div>

		<div>
			<div v-if="this.$store.state.setBalancesApiStatus == 'loading'" class="">
				<Loader size_prop="0.75rem" borderSize_prop="0.2rem"></Loader>
			</div>
			<div v-else-if="isHideBalance" class="">
				⬤ ⬤ ⬤ ⬤ ⬤ ⬤ ⬤
			</div>
			<div v-else class="font-semibold">
				{{ $store.getters['goldBalanceNew/getAvailableTradeGoldByContractId'](contractId) }} g
			</div>
		</div>

		<div class="cursor-pointer" @click="toggleBalance()">
			<IconEyeClose v-if="isHideBalance" width_prop="1rem" height_prop="1rem" />
			<IconEyeOpen v-if="!isHideBalance" width_prop="1rem" height_prop="1rem" />
		</div>
	</div>
</template>

<script>
import { configs } from '@bei/trading-formula'

import IconEyeClose from '../icons/IconEyeClose.vue'
import IconEyeOpen from '../icons/IconEyeOpen.vue'
import IconRefresh from '../icons/IconRefresh.vue'
import Loader from '../Loader.vue'

export default {
	name: 'AvailableGoldBalance_TradeTicket',

	components: {
		IconEyeClose,
		IconEyeOpen,
		IconRefresh,
		Loader,
	},

	props: {
		contractId: [String, Number],
	},

	data() {
		return {
			publicPath: process.env.BASE_URL,
			isHideBalance: false,
		}
	},

	computed: {
		currency() {
			return this.$store.state.currency
		},

		contractConfigs() {
			return configs.contractConfigs[this.contractId]
		}
	},

	methods: {
		toggleBalance() {
			this.isHideBalance = !this.isHideBalance
		},

		refreshBalance() {
			if (!this.$store.state.getDepositIsCooldown) {
				this.$store.dispatch('setBalances')
			}
		},
	}
}
</script>